import { useState, useEffect } from 'react';
import apiAxiosInstance from '../utils/axiosInstance';

interface Teacher {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  gradeLevel: string;
  teachingStandards: string[];
  state: string;
}

interface UseTeacherReturn {
  teacher: Teacher | null;
  loading: boolean;
  error: string | null;
}

export const useTeacher = (): UseTeacherReturn => {
  const [teacher, setTeacher] = useState<Teacher | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const verifyTeacher = async () => {
      try {
        const response = await apiAxiosInstance.get('/auth/verify');
        setTeacher(response.data.teacher);
      } catch (err: any) {
        console.error('Error verifying teacher:', err);
        setError(err.message || 'Failed to verify teacher authentication');
      } finally {
        setLoading(false);
      }
    };

    verifyTeacher();
  }, []);

  return { teacher, loading, error };
}; 